// extracted by mini-css-extract-plugin
export default {"paywallIcon":"OTlQHoHc7odNJIw05q6q__paywallIcon___"};